// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payouts-table {
  width: 100%;
}

tbody:before {
  content: "@";
  display: block;
  line-height: 8px;
  text-indent: -99999px;
}

.first_th {
  border-radius: var(--radius-sm) 0 0 var(--radius-sm);
}

.last_th {
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

.payouts_titleComponent {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.delete_filters {
  padding: 6px 12px;
  background-color: var(--bg);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  transition: all var(--transition-fast);
}

.delete_filters:hover {
  background-color: var(--primary-light);
  border-color: var(--primary);
  color: var(--primary);
}

.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  padding: 6px 12px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  width: min-content;
  cursor: pointer;
  outline: none;
  transition: border-color var(--transition-fast);
}

.custom-select:hover {
  border-color: var(--text-muted);
}

.custom-select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

th {
  background-color: var(--bg);
  padding: 12px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.payout_modalContainer {
  position: block;
  width: 100%;
  height: 100%;
}

.payouts_filter_component {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
}

.payouts_filter_component input {
  width: max-content;
  border: 1px solid var(--border);
  padding: 6px 12px;
  border-radius: var(--radius-sm);
}

.modal-button-div .valider {
  padding: 8px 20px;
  border-radius: var(--radius-sm);
  background-color: var(--success);
  border: none;
  color: white;
  font-weight: 600;
  transition: all var(--transition-fast);
}

.modal-button-div .valider:hover {
  background-color: #16A34A;
}

.modal_hr_button {
  margin: 20px 0;
  border: none;
  border-top: 1px solid var(--border-light);
}

.modal-button-div .refuser {
  padding: 8px 20px;
  border-radius: var(--radius-sm);
  background-color: var(--danger);
  border: none;
  color: white;
  font-weight: 600;
  transition: all var(--transition-fast);
}

.modal-button-div .refuser:hover {
  background-color: #DC2626;
}

.modal-button-div .manual {
  padding: 8px 20px;
  border-radius: var(--radius-sm);
  background-color: var(--primary);
  border: none;
  color: white;
  font-weight: 600;
  transition: all var(--transition-fast);
}

.modal-button-div .manual:hover {
  background-color: var(--primary-hover);
}

/*** WARNING ***/

.warning_deleted {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--danger-light);
  color: var(--danger);
  border: 1px solid var(--danger);
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
}

.multi_account_device {
  color: var(--danger);
}

.mono_account_device {
  color: var(--success);
}

.discrepancy_minor {
  color: yellow
}

.discrepancy_alert {
  color: red;
}

.discrepancy_ok {
  color: green;
}`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/Payouts/payouts.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":[".payouts-table {\n  width: 100%;\n}\n\ntbody:before {\n  content: \"@\";\n  display: block;\n  line-height: 8px;\n  text-indent: -99999px;\n}\n\n.first_th {\n  border-radius: var(--radius-sm) 0 0 var(--radius-sm);\n}\n\n.last_th {\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n}\n\n.payouts_titleComponent {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delete_filters {\n  padding: 6px 12px;\n  background-color: var(--bg);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  transition: all var(--transition-fast);\n}\n\n.delete_filters:hover {\n  background-color: var(--primary-light);\n  border-color: var(--primary);\n  color: var(--primary);\n}\n\n.custom-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  width: min-content;\n  cursor: pointer;\n  outline: none;\n  transition: border-color var(--transition-fast);\n}\n\n.custom-select:hover {\n  border-color: var(--text-muted);\n}\n\n.custom-select:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\nth {\n  background-color: var(--bg);\n  padding: 12px 12px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.payout_modalContainer {\n  position: block;\n  width: 100%;\n  height: 100%;\n}\n\n.payouts_filter_component {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 10px;\n}\n\n.payouts_filter_component input {\n  width: max-content;\n  border: 1px solid var(--border);\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n}\n\n.modal-button-div .valider {\n  padding: 8px 20px;\n  border-radius: var(--radius-sm);\n  background-color: var(--success);\n  border: none;\n  color: white;\n  font-weight: 600;\n  transition: all var(--transition-fast);\n}\n\n.modal-button-div .valider:hover {\n  background-color: #16A34A;\n}\n\n.modal_hr_button {\n  margin: 20px 0;\n  border: none;\n  border-top: 1px solid var(--border-light);\n}\n\n.modal-button-div .refuser {\n  padding: 8px 20px;\n  border-radius: var(--radius-sm);\n  background-color: var(--danger);\n  border: none;\n  color: white;\n  font-weight: 600;\n  transition: all var(--transition-fast);\n}\n\n.modal-button-div .refuser:hover {\n  background-color: #DC2626;\n}\n\n.modal-button-div .manual {\n  padding: 8px 20px;\n  border-radius: var(--radius-sm);\n  background-color: var(--primary);\n  border: none;\n  color: white;\n  font-weight: 600;\n  transition: all var(--transition-fast);\n}\n\n.modal-button-div .manual:hover {\n  background-color: var(--primary-hover);\n}\n\n/*** WARNING ***/\n\n.warning_deleted {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: var(--danger-light);\n  color: var(--danger);\n  border: 1px solid var(--danger);\n  padding: 10px 14px;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.multi_account_device {\n  color: var(--danger);\n}\n\n.mono_account_device {\n  color: var(--success);\n}\n\n.discrepancy_minor {\n  color: yellow\n}\n\n.discrepancy_alert {\n  color: red;\n}\n\n.discrepancy_ok {\n  color: green;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
